import '@hotwired/turbo-rails';
import { Application } from '@hotwired/stimulus';
import { AccordionController } from '@inked/accordion';
import { AddressController } from '@inked/address';
import { AriaController } from '@inked/aria';
import { AutoSubmitController } from '@inked/auto-submit';
import {
  bindTurboBeforeCacheEvents,
  bindTurboLoadEvents,
} from '@inked/utilities';
import { CharacterCounterController } from '@inked/character-counter';
import { CloudflareTurnstileController } from '@inked/cloudflare-turnstile';
import { ConsentController } from '@inked/consent';
import { CounterController } from '@inked/counter';
import { DataLayerController } from '@inked/data-layer';
import { DialogController } from '@inked/dialog';
import { DisplayController } from '@inked/display';
import { DisplayWhenCheckedController } from '@inked/display-when-checked';
import { FaqController } from '@inked/faq';
import { FileUploadController } from '@inked/file-upload';
import { FocusStealController } from '@inked/focus-steal';
import { FormController } from '@inked/form';
import { FormToHistoryState } from '@inked/form-to-history-state';
import { MediaSwapController } from '@inked/media-swap';
import { ParamsController } from '@inked/params';
import { PopoverController } from '@inked/popover';
import { PreventDefaultController } from '@inked/prevent-default';
import { ProductVariantsFormController } from '@inked/product-variants-form';
import { ScrollViewController } from '@inked/scroll-view';
import { SlideshowController } from '@inked/slideshow';
import { SortableController } from '@inked/sortable';
import { TextareaController } from '@inked/textarea';
import { TriggerController } from '@inked/trigger';
import { VerifyAddressController } from '@inked/verify-address';
import { VideoController } from '@inked/video';

bindTurboBeforeCacheEvents();
bindTurboLoadEvents();

const app = Application.start();

app.debug = process.env.NODE_ENV !== 'production';

app.register('accordion', AccordionController);
app.register('address', AddressController);
app.register('aria', AriaController);
app.register('auto-submit', AutoSubmitController);
app.register('character-counter', CharacterCounterController);
app.register('cloudflare-turnstile', CloudflareTurnstileController);
app.register('consent', ConsentController);
app.register('counter', CounterController);
app.register('data-layer', DataLayerController);
app.register('dialog', DialogController);
app.register('display', DisplayController);
app.register('display-when-checked', DisplayWhenCheckedController);
app.register('faq', FaqController);
app.register('file-upload', FileUploadController);
app.register('focus-steal', FocusStealController);
app.register('form', FormController);
app.register('form-to-history-state', FormToHistoryState);
app.register('media-swap', MediaSwapController);
app.register('params', ParamsController);
app.register('popover', PopoverController);
app.register('prevent-default', PreventDefaultController);
app.register('product-variants-form', ProductVariantsFormController);
app.register('scroll-view', ScrollViewController);
app.register('slideshow', SlideshowController);
app.register('sortable', SortableController);
app.register('textarea', TextareaController);
app.register('trigger', TriggerController);
app.register('verify-address', VerifyAddressController);
app.register('video', VideoController);
